<template>
  <div class="footer">
    <div class="footer_list">
      <ul>
        <li>
          <h2 style="margin-bottom: 16px">产品中心</h2>
          <div class="select_menu">
            <router-link
              :to="
                item.child.length
                  ? `/product/productdetail/${item.id}`
                  : `/product/profile/${item.id}`
              "
              v-for="item in menu_product"
              tag="p"
              :key="item.id"
              >{{ item.name }}</router-link
            >
          </div>
        </li>
        <li>
          <h2 style="margin-bottom: 16px">解决方案</h2>
          <router-link
            :to="
              item.child.length
                ? `/solution/solutiondetail/${item.id}`
                : `/solution/profile/${item.id}`
            "
            v-for="item in menu_solution"
            tag="p"
            :key="item.id"
            >{{ item.name }}</router-link
          >
        </li>
        <li class="aboutUs">
          <h2>关于我们</h2>
          <p
            style="
              margin-top: 16px;
              color: rgba(255, 255, 255, 0.5);
              text-decriation: none;
            "
            @click.stop="goAboutPage()"
          >
            <a
              href="#about_anchor_introduce"
              style="color: rgba(255, 255, 255, 0.5); text-decoration: none"
              >公司简介</a
            >
          </p>
          <p
            style="color: rgba(255, 255, 255, 0.5); text-decriation: none"
            @click.stop="goAboutPage()"
          >
            <a
              href="#about_anchor_dees"
              style="color: rgba(255, 255, 255, 0.5); text-decoration: none"
              >发展历程</a
            >
          </p>
          <p
            style="color: rgba(255, 255, 255, 0.5); text-decriation: none"
            @click.stop="goAboutPage()"
          >
            <a
              href="#about_anchor_join"
              style="color: rgba(255, 255, 255, 0.5); text-decoration: none"
              >企业文化</a
            >
          </p>
          <p
            style="color: rgba(255, 255, 255, 0.5); text-decriation: none"
            @click.stop="goAboutPage()"
          >
            <a
              href="#about_anchor_director"
              style="color: rgba(255, 255, 255, 0.5); text-decoration: none"
              >质量方针</a
            >
          </p>
        </li>
        <li>
          <div class="logo">
            <img src="../assets/logo-footer.png" alt="国基科技" />
          </div>
          <div class="photo">
            <img :src="src" alt="" />
          </div>
          <p>扫描关注官方微信</p>
        </li>
        <li class="tel_address">
          <h2>联系我们</h2>
          <p style="text-align: left; margin-top: 16px; line-height: 25px">
            公司地址：<span class="address"
              >{{address}}</span
            >
          </p>
          <p style="text-align: left; height: 25px">
            QQ咨询：<span class="tel">{{qqNum}}</span>
          </p>
          <p style="text-align: left; height: 25px">
            全国热线：<span class="tel">{{phoneOne}}</span>
          </p>
           <p style="text-align: left; height: 25px">
            公司邮箱：<span class="tel">{{email}}</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="footer_icp">{{beian}}</div>
  </div>
</template>


<script>
import Axios from "axios";
export default {
  data() {
    return {
      src: "",
      address:'',
      qqNum:'',
      phoneOne:'',
      email:'',
      beian:'',
      menu_product: [],
      menu_solution: [],
    };
  },
  mounted() {
    Axios({
      url: "/apiv2/sconfig/getlist",
      data: {},
      method: "GET",
    }).then((res) => {
      for (var i = 0; i < res.data.data.rows.length; i++) {
        if (res.data.data.rows[i].sc_key.slice(0, 6) == "QRCODE") {
          this.src =
            res.data.data.rows[i].sc_value;
        }
        if (res.data.data.rows[i].sc_key.slice(0, 7) == "CONTACT") {
          this.address =res.data.data.rows[i].sc_value;
        }
        if (res.data.data.rows[i].sc_key.slice(0, 5) == "EMAIL") {
          this.email =res.data.data.rows[i].sc_value;
        }
        if (res.data.data.rows[i].sc_key.slice(0, 5) == "BEIAN") {
          this.beian =res.data.data.rows[i].sc_value;
        }
        if (res.data.data.rows[i].sc_key.slice(0, 5) == "QQNUM") {
          this.qqNum =res.data.data.rows[i].sc_value;
        }
        if (res.data.data.rows[i].sc_key.slice(0, 8) == "PHONEONE") {
          this.phoneOne =res.data.data.rows[i].sc_value;
        }
      }
    });
    Axios({
			url:'/apiv2/bdoctree/gettree?bdContenttype=产品中心',
			data: {},
			method: 'GET',
		}).then((res) => {
			this.menu_product = res.data.data
		})
		Axios({
			url: '/apiv2/bdoctree/gettree?bdContenttype=解决方案',
			data: {},
			method: 'GET',
		}).then((res) => {
			this.menu_solution = res.data.data
		})
  },
  methods: {
    goAboutPage() {
      this.$router.push("/investor");
    },
  },
};
</script>


<style lang="scss" scoped>
@media (min-width: 1200px) {
  @import "../style/base.scss";
  @import "../style/footer.scss";
}
@media (max-width: 1199px) {
  @import "../style/mb.scss";
  @import "../style/m-footer.scss";
}
</style>